 <div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">
      Edit PurchaseOrder for PoNumber: {{ editOrder.poNumber }}
    </mat-card-title>

    <mat-card-content>
      <form [formGroup]="editPurchaseOrderForm" novalidate>
        <div class="row">
          <!-- Vendor -->
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" *ngIf="vendorOptions.length > 0">
            <mat-form-field color="accent" appearance="fill">
              <mat-label>Vendor</mat-label>
              <mat-select formControlName="vendorCode" required>
                <mat-option [value]="null">Select an option</mat-option>
                <mat-option *ngFor="let vendor of vendorOptions" [value]="vendor.vendorCode">
                  {{ vendor.vendorName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="editPurchaseOrderForm.get('vendorCode')?.hasError('required')">
                Vendor is required.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Order Date -->
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
            <mat-form-field color="accent" appearance="fill">
              <mat-label>Order Date</mat-label>
              <input
                matInput
                [matDatepicker]="picker1"
                formControlName="orderDate"
                (dateChange)="onDateChange($event)"
                required
                [max]="today"
                readonly
              />
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <mat-error *ngIf="editPurchaseOrderForm.get('orderDate')?.hasError('required')">
                Order Date is required.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Description -->
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
            <mat-form-field color="accent" appearance="fill">
              <mat-label>Description</mat-label>
              <input
                matInput
                type="text"
                formControlName="description"
                maxlength="100"
                required
                appInputValidator 
                [sanitizeScriptTags]="true" 
                [hasAtLeastOneAlphabet]="true"
              />
              <mat-error *ngIf="editPurchaseOrderForm.get('description')?.hasError('required')">
                Description is required.
              </mat-error>
              <mat-error *ngIf="editPurchaseOrderForm.get('description')?.hasError('maxlength')">
                Max 100 characters allowed.
              </mat-error>
               <mat-error *ngIf="editPurchaseOrderForm.get('description')?.hasError('maxlength')">
                Description must contain at least one alphabet character.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Address -->
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <mat-form-field color="accent" appearance="fill">
              <mat-label>Address</mat-label>
              <input
                matInput
                type="text"
                formControlName="address"
                maxlength="250"
                required
                appInputValidator 
                [sanitizeScriptTags]="true" 
                [hasAtLeastOneAlphabet]="true"
              />
              <mat-error *ngIf="editPurchaseOrderForm.get('address')?.hasError('required')">
                Address is required.
              </mat-error>
              <mat-error *ngIf="editPurchaseOrderForm.get('address')?.hasError('maxlength')">
                Max 250 characters allowed.
              </mat-error>
               <mat-error *ngIf="editPurchaseOrderForm.get('address')?.hasError('noAlphabet')">
                 Address Code must contain at least one alphabet character.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>

    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <button mat-raised-button type="button" class="btn btn-rose" (click)="close()">
          Close
        </button>

        <button
          mat-raised-button
          type="button"
          class="btn btn-rose"
          (click)="updatePurchaseOrder()"
          [disabled]="!editPurchaseOrderForm?.valid || !isAdminGroupUser"
        >
          Update
        </button>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
